import type { RootState } from 'state';
import type { FlightCalendarsFiltersState } from '../slice';

function getAirportsTo(state: RootState): FlightCalendarsFiltersState['airportsTo'] {
  const { airportsTo } = state.flightCalendars.filtersValues;
  return airportsTo;
}

export default getAirportsTo;
